// ──────────────────────────────────────────────────────
// Design Tokens — Q Care AI Kiosk
// Premium dark theme with teal/cyan AI accent
// ──────────────────────────────────────────────────────

export const colors = {
    // Core palette
    background: '#0B0F1A',
    surface: '#111827',
    surfaceElevated: '#1A2235',
    surfaceGlass: 'rgba(26, 34, 53, 0.7)',

    // Accent
    accent: '#06B6D4',       // cyan-500
    accentLight: '#22D3EE',  // cyan-400
    accentDark: '#0891B2',   // cyan-600
    accentGlow: 'rgba(6, 182, 212, 0.15)',

    // Text
    textPrimary: '#F9FAFB',
    textSecondary: '#9CA3AF',
    textMuted: '#6B7280',

    // Semantic
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',

    // Border
    border: 'rgba(255, 255, 255, 0.08)',
    borderAccent: 'rgba(6, 182, 212, 0.3)',
} as const;

export const spacing = {
    touch: '44px',      // minimum touch target
    touchLg: '56px',    // large touch target
    cardPadding: '24px',
    sectionGap: '32px',
    screenPadding: '24px',
} as const;

export const fontSize = {
    hero: '2.5rem',      // 40px
    title: '1.75rem',    // 28px
    subtitle: '1.25rem', // 20px
    body: '1rem',        // 16px
    caption: '0.875rem', // 14px
    small: '0.75rem',    // 12px
} as const;

export const borderRadius = {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    full: '9999px',
} as const;

export const animation = {
    fast: '150ms',
    normal: '300ms',
    slow: '500ms',
    spring: { type: 'spring' as const, stiffness: 300, damping: 30 },
    springGentle: { type: 'spring' as const, stiffness: 200, damping: 25 },
} as const;

/** Skin type options — Arabic labels mapped to English API values */
export const SKIN_TYPES = [
    { label: 'دهنية', value: 'oily' },
    { label: 'جافة', value: 'dry' },
    { label: 'مختلطة', value: 'combination' },
    { label: 'حساسة', value: 'sensitive' },
    { label: 'ما أعرف', value: 'unknown' },
] as const;

export const INACTIVITY_TIMEOUT_MS = 90_000; // 90 seconds
